import React from 'react';
import DataTableWithForm from '../components/DataTableWithForm';

const ProductSupplier = () => {
  return (
    <DataTableWithForm
      title="Product Supplier"
      fetchUrl="/zts/admin/v1.0/product/supplier/"
      createUrl="/zts/admin/v1.0/product/supplier/"
      updateUrl={(id) => `/zts/admin/v1.0/product/supplier/${id}/`}
      deleteUrl={(id) => `/zts/admin/v1.0/product/supplier/${id}/`}
      columns={[
        { field: 'name', label: 'Name' },
        { field: 'category', label: 'Category' },
        { field: 'is_active', label: 'Active', format: val => val ? 'True' : 'False' }
      ]}
      formFields={[
        { name: 'name', label: 'Name' },
        { name: 'category', label: 'Category' },
        { name: 'is_active', label: 'Is Active (true / false)' }
      ]}
    />
  );
};

export default ProductSupplier;